module.exports = __webpack_public_path__ + "img/img3.458279a5.png";